export const actionTypes = {
  GET_HASHTAG_RECOMMENT_REQUEST: 'GET_HASHTAG_RECOMMENT_REQUEST',
  GET_HASHTAG_RECOMMENT_SUCESS: 'GET_HASHTAG_RECOMMENT_SUCESS',
  GET_HASHTAG_RECOMMENT_ERROR: 'GET_HASHTAG_RECOMMENT_ERROR'
};

export const requestHashtagRecomment = () => ({
  type: actionTypes.GET_HASHTAG_RECOMMENT_REQUEST
});
